
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import { PosLeaderboard } from "@/domain/entities/PosLeaderboard";
import { formatPriceRP } from "@/app/infrastructures/misc/Utils";
import SliderLeaderboard from "./slider-leaderboard.vue";

class Props {
  data = prop({
    type: PosLeaderboard,
    default: new PosLeaderboard()
  });
}

@Options({
  components: {
    OverlayPanel,
    SliderLeaderboard
  }
})
export default class CardReward extends Vue.with(Props) {
  isActiveTooltip = false;
  toggleTooltip(event: any) {
    this.isActiveTooltip = !this.isActiveTooltip;
    const refs: any = this.$refs;
    refs["opTooltip"].toggle(event);
  }

  formatPriceRP = formatPriceRP;
}
